import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "displacementView__controlWrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "当前默认油耗表", -1)
const _hoisted_3 = { class: "fl-row-center" }
const _hoisted_4 = { class: "displacementView__dataWrap" }
const _hoisted_5 = { class: "displacementView__dataTable" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "排量（T系列）"),
  /*#__PURE__*/_createElementVNode("th", null, "车主众测油耗（L/100KM）")
], -1)
const _hoisted_7 = { class: "displacementView__dataTable" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "排量（L系列）"),
  /*#__PURE__*/_createElementVNode("th", null, "车主众测油耗（L/100KM）")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_app_input_number = _resolveComponent("app-input-number")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    class: "utils__pageContainer displacementView",
    title: "油补油耗配置"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.editing)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editing = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("修改")
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  disabled: _ctx.submiting,
                  loading: _ctx.submiting,
                  onClick: _ctx.onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                }, 8, ["disabled", "loading", "onClick"]),
                _createVNode(_component_a_button, {
                  type: "default",
                  onClick: _ctx.onCancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("取消")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.t, (item, $index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id
            }, [
              _createElementVNode("td", null, _toDisplayString(item.displacement), 1),
              _createElementVNode("td", null, [
                (!_ctx.editing)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(item.oilConsumption), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_app_input_number, {
                  value: _ctx.formData.t[$index].oilConsumption,
                  "onUpdate:value": ($event: any) => ((_ctx.formData.t[$index].oilConsumption) = $event),
                  "int-length": 2
                }, null, 8, ["value", "onUpdate:value"]), [
                  [_vShow, _ctx.editing]
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("table", _hoisted_7, [
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.l, (item, $index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id
            }, [
              _createElementVNode("td", null, _toDisplayString(item.displacement), 1),
              _createElementVNode("td", null, [
                (!_ctx.editing)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(item.oilConsumption), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_app_input_number, {
                  value: _ctx.formData.l[$index].oilConsumption,
                  "onUpdate:value": ($event: any) => ((_ctx.formData.l[$index].oilConsumption) = $event),
                  "int-length": 2
                }, null, 8, ["value", "onUpdate:value"]), [
                  [_vShow, _ctx.editing]
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}